module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAFVJREFUeNpi/P//PwO5gHHANDPhkywoKFhNls35+flwjRMnTgwlWnNubi6GjZMnTw4lqDkrKwunU6dNmxaKU3NGRsZqQoE0Y8aM0IGPqlHNJAKAAAMAUdc74q5FO1cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/folder_close.png
// module id = Wahp
// module chunks = 0